import React, {useEffect, useState} from "react";
import "./zoomslider.css";
import {Slider} from "antd";

type Props = {
  defaultValue?: number;
  min?: number;
  max?: number;
  zoom?: number;
  onChange: (value: number) => void;
};

const OFFSET = 1;
export const ZoomSlider = ({onChange, defaultValue = 13, min = 10, max = 21, zoom}: Props) => {
  const [value, setValue] = useState(defaultValue * OFFSET);
  
  useEffect(() => {
    if (zoom) setValue(zoom)
  }, [zoom]);
  
  // (ref, () => ({
  //   setValue: (zoom: number) => {
  //     console.log("handleM zoom", zoom, value, zoom != value);
  //     zoom = OFFSET * zoom;
  //     if (zoom != value) {
  //       setValue(zoom);
  //     }
  //   },
  // }), [value]);
  //
  const handleChange = (value: number) => {
    console.log("handleM zoom", zoom, value, zoom != value);
    zoom = OFFSET * value;
    setValue(value);
    onChange(value);
  };
  
  const tooltipFormatter = (value?: number) => {
    switch (value) {
      case 13 * OFFSET:
        return "13 우편번호";
      case 14 * OFFSET:
        return "14 지역";
      default:
        return value ? value / OFFSET : value;
    }
  };
  
  return (<div className={"zoom-slider"}>
    <Slider
      dots
      value={value}
      vertical
      min={min * OFFSET}
      tooltip={{formatter: tooltipFormatter}}
      defaultValue={defaultValue * OFFSET}
      max={max * OFFSET}
      onChange={handleChange}
    />
  </div>);
};
